








































import { Component, Vue, Prop } from "vue-property-decorator";
import { Profile } from "@/models/profile";
import moment from "moment";

@Component({
  name: "ProfileComponent",
  filters: {
    dateFormat(setDate: string): string | null {
      return moment(setDate).format("YYYY年 MM月DD日");
    },
    genderFormat(gender: string): string | null {
      if (!gender) {
        return null;
      } else {
        switch (gender) {
          case "other":
            return "指定しない";
          case "male":
            return "男性";
          case "female":
            return "女性";
          default:
            return "指定しない";
        }
      }
    },
  },
})
export default class ProfileComponent extends Vue {
  @Prop({ default: {} })
  pProfile!: any;

  get getFullName(): string {
    // const firstName = this.pProfile.first_name || "";
    // const lastName = this.pProfile.last_name || "";
    // const userName = firstName + " " + lastName;
    // return userName.trim();
    return this.pProfile.name || "";
  }

  get address() {
    const prefecture = this.pProfile.prefecture || "";
    const city = this.pProfile.city || "";
    return `${prefecture} ${city}`;
  }
}
